import { GzRemoveADIntegrationWebComponent } from './component/GzRemoveADIntegrationWebComponent';

export { GzRemoveADIntegrationWebComponent };
